module.exports = __webpack_public_path__ + "img/ignis-logo.36490d99.png";